module.exports = __webpack_public_path__ + "img/photo3.1fba375c.png";